export class ClipboardUtils {

    public static async copyAsync(data: string): Promise<boolean> {
        //@ts-ignore
        const permissionDesc: PermissionDescriptor = { name: 'clipboard' };
        const permissionStatus: PermissionStatus = await navigator.permissions.query(permissionDesc);
        console.log("ClipboardUtils : " + permissionStatus);

        if (permissionStatus.state === "granted" || permissionStatus.state === "prompt") {
            try {
                await navigator.clipboard.writeText(data);
                return true;
            } catch (error) {
                console.error("ClipboardUtils copy : error -> ", error);
                return false;
            }
        }
        return true;
    }

    public static copy(data?: string): Promise<boolean> {
        if (!data) {
            return Promise.resolve(false);
        }
        return new Promise<boolean>((resolve, reject) => {
            navigator.clipboard.writeText(data).then(() => {
                resolve(true);
            }, () => {
                resolve(false);
                //reject({= result: false})
            });
        });
    }
}